import { render } from "./thirdstepLoggedGroomingView.vue?vue&type=template&id=4e3e9ebc&scoped=true"
import script from "./thirdstepLoggedGroomingView.vue?vue&type=script&lang=js"
export * from "./thirdstepLoggedGroomingView.vue?vue&type=script&lang=js"

import "./thirdstepLoggedGroomingView.vue?vue&type=style&index=0&id=4e3e9ebc&scoped=true&lang=css"

import exportComponent from "E:\\coding\\pharaoh_frog_barber\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e3e9ebc"]])

export default __exports__